module.exports = __webpack_public_path__ + "img/box-packaging-sm-tmp@1x.123a1874.png";